import { render } from "./OverrideInfoPanel.vue?vue&type=template&id=70f9996e&scoped=true"
import script from "./OverrideInfoPanel.vue?vue&type=script&lang=ts"
export * from "./OverrideInfoPanel.vue?vue&type=script&lang=ts"

import "./OverrideInfoPanel.vue?vue&type=style&index=0&id=70f9996e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70f9996e"

export default script